import {Currency} from '../reusables/currency';
import {TicketingAffiliate, TicketingEvents, TicketingOrderDetails, TicketingSalesChannel, TicketingSalesOperator,} from './ticketing-objects';
import {DateObject} from '../reusables/date-object';
import {InvoiceOrderStatusTranslationsService} from 'src/app/shared/translations';


/**
 * Blueprint for the customer status object.
 */
export class CancellationTicket {
  public id: number;
  public type: string;
  public affiliate: TicketingAffiliate;
  public events: Array<TicketingEvents>;
  public orderDetails: TicketingOrderDetails;
  public saleOperator: TicketingSalesOperator;
  public salesChannel: TicketingSalesChannel;

  constructor(data?: any, private translations?: InvoiceOrderStatusTranslationsService) {
    this.id = data.id;
    this.type = data.type;
    this.affiliate = new TicketingAffiliate(data.affiliate);
    this.orderDetails = new TicketingOrderDetails(data.orderDetails, translations);
    this.saleOperator = new TicketingSalesOperator(data.saleOperator);
    this.salesChannel = new TicketingSalesChannel(data.salesChannel, translations);

    this.events = [];
    data.events.forEach(event => {
      this.events.push(new TicketingEvents(event));
    });
  }

  get date(): DateObject {
    return this.orderDetails.invoiceDate;
  }

  get cancellationNumber(): string {
    return this.orderDetails.displayInvoiceNumber;
  }

  get invoiceNumber(): string {
    return this.orderDetails.invoiceNumber;
  }

  get totalAmount(): Currency {
    return this.orderDetails.paymentDetails;
  }

  get translatedType(): string | string {
    return this.translations.i18nCancellation;
  }
}
